import React, { useState, useContext, useEffect } from "react";
import { Fade } from "react-reveal";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  educationInfo,
  // skillsSection,
  // openSource,
  // blogSection,
  // talkSection,
  // achievementSection,
  resumeSection
} from "../../portfolio";

function Header() {
  const { isDark } = useContext(StyleContext);
  const [isContentReady, setIsContentReady] = useState(false);
  
  const viewGreeting = greeting.displayGreeting;
  const viewExperience = workExperiences.display;
  const viewEducation = educationInfo.display;
  // const viewOpenSource = openSource.display;
  // const viewSkills = skillsSection.display;
  // const viewAchievement = achievementSection.display;
  // const viewBlog = blogSection.display;
  // const viewTalks = talkSection.display;
  const viewResume = resumeSection.display;

  useEffect(() => {
    document.fonts.ready.then(() => {
      const checkLogoReady = () => {
        const logo = document.querySelector('.logo');
        if (logo) {
          setIsContentReady(true);
        } else {
          requestAnimationFrame(checkLogoReady);
        }
      };
      checkLogoReady();
    });
  }, []);

  const closeMenu = () => {
    const menuBtn = document.getElementById("menu-btn");
    if (menuBtn) {
      menuBtn.checked = false;
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); 
    const menuBtn = document.getElementById("menu-btn");
    const isMenuOpen = menuBtn && menuBtn.checked;

    if (isMenuOpen) {
      closeMenu(); // Close mobile menu
      // Wait for collapse, then scroll
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 300);
    } else {
      // Desktop or menu already closed: scroll instantly
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const scrollToBottom = (e) => {
    e.preventDefault(); 
    const menuBtn = document.getElementById("menu-btn");
    const isMenuOpen = menuBtn && menuBtn.checked;

    if (isMenuOpen) {
      closeMenu(); // Close mobile menu
      // Wait for collapse, then scroll down
      setTimeout(() => {
        window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
      }, 300);
    } else {
      // Desktop or menu already closed: scroll instantly
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
    }
  };

  const scrollToSection = (e, sectionId) => {
    e.preventDefault(); 
    const menuBtn = document.getElementById("menu-btn");
    const isMenuOpen = menuBtn && menuBtn.checked;

    if (isMenuOpen) {
      closeMenu(); // Close mobile menu
      // Wait for collapse, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    } else {
      // Desktop or menu already closed: scroll instantly
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // Consolidating all standard navigation links into an array for cleaner rendering
  const navLinks = [
    // { id: "skills", name: "Skills", view: viewSkills },
    { id: "intro", name: "Introduction", view: viewGreeting, isTopLink: true },
    { id: "experience", name: "Experience", view: viewExperience },
    { id: "education", name: "Education", view: viewEducation },
    // { id: "opensource", name: "Open Source", view: viewOpenSource },
    // { id: "achievements", name: "Achievements", view: viewAchievement },
    // { id: "blogs", name: "Blogs", view: viewBlog },
    // { id: "talks", name: "Talks", view: viewTalks },
    { id: "contact", name: "Contact", view: true, isBottomLink: true}, // Contact always visible
  ];

  return (
    <Headroom pin={true}>
      <header className={isDark ? "dark-menu header" : "header"}>
        {isContentReady ? (
          <Fade duration={400}>
            <a href="/" className="logo">
              <span className="grey-color"> &lt;</span>
              <span className={isDark ? "logo-name-dark" : "logo-name"}>
                {greeting.username}
              </span>
              <span className="grey-color">/&gt;</span>
            </a>
          </Fade>
        ) : (
          <a href="/" className="logo" style={{ opacity: 0 }}>
            <span className="grey-color"> &lt;</span>
            <span className={isDark ? "logo-name-dark" : "logo-name"}>
              {greeting.username}
            </span>
            <span className="grey-color">/&gt;</span>
          </a>
        )}

        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{ color: "white" }}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          
          {/* Dynamically map over all standard links */}
          {navLinks.map((link) => {
            if (!link.view) return null;

            if (link.isTopLink) {
              return (
                <li key={link.id}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a onClick={scrollToTop} style={{ cursor: "pointer" }}>
                    {link.name}
                  </a>
                </li>
              );
            }

            if (link.isBottomLink) {
              return (
                <li key={link.id}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a onClick={scrollToBottom} style={{ cursor: "pointer" }}>
                    {link.name}
                  </a>
                </li>
              );
            }

            return (
              <li key={link.id}>
                <a href={`#${link.id}`} onClick={(e) => scrollToSection(e, link.id)}>
                  {link.name}
                </a>
              </li>
            );
          })}

          {/* Special Links: Resume & Theme Toggle */}
          {viewResume && (
            <li>
              <a
                href="/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                Resume
              </a>
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={closeMenu} style={{ cursor: "pointer" }}>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}

export default Header;
